import { useCallback, useRef } from "react";
//#region src/use-promises-queue.ts
function usePromisesQueue() {
	const queueRef = useRef(Promise.resolve());
	return {
		appendQueue: useCallback((promise) => {
			queueRef.current = queueRef.current.then(() => {
				return typeof promise === "function" ? promise() : promise;
			}).catch(() => {});
		}, []),
		clearQueue: useCallback(() => {
			queueRef.current = Promise.resolve();
		}, [])
	};
}
//#endregion
export { usePromisesQueue };
